import api from "./axios";

export const trackerApi = {
  list: (params?: Record<string, string>) =>
    api.get("/trackers", { params }).then((r) => r.data),
  getActive: () => api.get("/trackers/active").then((r) => r.data),
  create: (data: {
    description?: string;
    projectId: string;
    from: string;
    through?: string;
    billable?: boolean;
  }) => api.post("/trackers", data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    api.patch(`/trackers/${id}`, data).then((r) => r.data),
  remove: (id: string) => api.delete(`/trackers/${id}`),
};

export const dashboardApi = {
  getStats: (params?: Record<string, string>) =>
    api.get("/dashboard/stats", { params }).then((r) => r.data),
  getDailyHours: (params?: Record<string, string>) =>
    api.get("/dashboard/daily-hours", { params }).then((r) => r.data),
  getRecent: () => api.get("/dashboard/recent").then((r) => r.data),
};
